import { render, staticRenderFns } from "./SliderV.vue?vue&type=template&id=800b1afa&scoped=true&"
import script from "./SliderV.vue?vue&type=script&lang=js&"
export * from "./SliderV.vue?vue&type=script&lang=js&"
import style0 from "./SliderV.vue?vue&type=style&index=0&id=800b1afa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "800b1afa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VSlideItem } from 'vuetify/lib/components/VSlideGroup';
installComponents(component, {VBtn,VCard,VIcon,VImg,VSlideItem})
